var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCvCaboVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_9304)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0273 20.5331H-14.5617V38.6869H60.0361L60.0273 20.5331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9746 0H-14.5791V22.6129H59.9746V0ZM59.9482 34.0074H-15.1431V45.12H59.9482V34.0074Z",
    fill: "#081873"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9482 26.6666H-14.6055V30.1564H59.9482V26.6666Z",
    fill: "#DE3929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6079 35.1795L37.0263 36.9772H35.1404L36.6738 38.0964L36.0921 39.903L37.6079 38.775L39.1413 39.8942L38.5508 38.0876L40.0842 36.9684H38.1895M21.2166 22.0665L20.6262 23.873H18.7491L20.2825 24.9834L19.7009 26.79L21.2343 25.6708L22.7676 26.79L22.186 24.9834L23.7194 23.873H21.8159M41.3796 29.5483L40.798 31.3548H38.9033L40.4279 32.4828L39.8375 34.2806L41.3708 33.1702L42.9042 34.2806L42.3226 32.4828L43.856 31.3637H41.9613M21.2166 29.0372L20.6262 30.8349H18.7491L20.2825 31.9541L19.7009 33.7518L21.2343 32.6415L22.7676 33.7607L22.186 31.9541L23.7194 30.8349H21.8159M25.385 16.5851L24.7945 18.3828H22.891L24.4244 19.502L23.8428 21.3086L25.3761 20.1894L26.9095 21.3086L26.3191 19.502L27.8613 18.3828H25.9578M31.6418 14.3996L31.0514 16.2062H29.1567L30.6901 17.3165L30.1085 19.1231L31.6418 18.0127L33.1752 19.1231L32.5848 17.3165L34.1181 16.2062H32.2323M37.9163 16.4617L37.3259 18.2683H35.4312L36.9646 19.3787L36.3741 21.1852L37.9163 20.066L39.4497 21.1852L38.8593 19.3787L40.3926 18.2683H38.4891M41.5559 22.0753L40.9743 23.8818H39.0708L40.613 24.9922L40.0225 26.7988L41.5559 25.6796L43.0893 26.7988L42.5076 24.9922L44.041 23.8818H42.1463M31.6418 37.0477L31.0514 38.8543H29.1567L30.6901 39.9647L30.0996 41.7712L31.6418 40.652L33.1752 41.7712L32.5848 39.9647L34.1181 38.8543H32.2323M24.9884 35.1795L24.4068 36.9772H22.5121L24.0366 38.0964L23.4462 39.903L24.9796 38.7838L26.5218 39.903L25.9313 38.0964L27.4647 36.9772H25.57",
    fill: "#FFCE08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_9304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvCaboVerde);
export default __webpack_public_path__ + "static/media/cv Cabo Verde.dd25dcf2723fdf305a04e8101d231ca4.svg";
export { ForwardRef as ReactComponent };